export function formatPrice(price: number | null | undefined): string {
  if (price === null || price === undefined) return "$--,---";
  return (
    "$" +
    price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  );
}

export function formatVolumeUsd(volume: number | null | undefined): string {
  if (volume === null || volume === undefined) return "$---,---,---";
  return (
    "$" + volume.toLocaleString("en-US", { maximumFractionDigits: 0 })
  );
}

export function formatBtc(btc: number | null | undefined): string {
  if (btc === null || btc === undefined) return "--,---.-- BTC";
  return (
    btc.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
    " BTC"
  );
}

export function formatRatio(ratio: number | null | undefined): string {
  if (ratio === null || ratio === undefined) return "--.--";
  return ratio.toFixed(2);
}

/** Ported from legacy/dashboard.html's `calculatePercentChange` verbatim:
 * a previous value of 0/null/undefined has no meaningful percent change
 * (avoids a division-by-zero / Infinity), so this returns null rather than
 * fabricating a number. */
export function calculatePercentChange(
  current: number,
  previous: number | null | undefined
): number | null {
  if (!previous || previous === 0) return null;
  return ((current - previous) / previous) * 100;
}

/** Ported from legacy/dashboard.html's `formatDate`: a "YYYY-MM-DD" day_utc
 * string rendered as "MM/DD" for the volume-history list. */
export function formatDayUtc(dayUtc: string): string {
  const parts = dayUtc.split("-");
  return `${parts[1]}/${parts[2]}`;
}

/** Server timestamps are UTC ISO-8601 with an explicit offset (SPEC.md §7)
 * -- the Date constructor parses that correctly with no ambiguity, unlike
 * the legacy dashboard's naive-timestamp handling that datasearch.html had
 * to work around client-side. Always render in the viewer's local time. */
export function formatLocalTime(tsUtc: string | null | undefined): string {
  if (!tsUtc) return "--:--:--";
  const d = new Date(tsUtc);
  if (Number.isNaN(d.getTime())) return "--:--:--";
  return d.toLocaleTimeString("en-US", { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

/** SW-22 device list: a short relative "last seen" ("just now", "5 min ago",
 * "3 h ago", "2 d ago") for the past week, else a short local date
 * ("Aug 30"). Unknown/unparseable = "never". `nowMs` is injectable for tests. */
export function formatLastSeen(tsUtc: string | null | undefined, nowMs = Date.now()): string {
  if (!tsUtc) return "never";
  const t = new Date(tsUtc).getTime();
  if (Number.isNaN(t)) return "never";
  const sec = Math.max(0, Math.floor((nowMs - t) / 1000));
  if (sec < 60) return "just now";
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86_400) return `${Math.floor(sec / 3600)} h ago`;
  if (sec < 7 * 86_400) return `${Math.floor(sec / 86_400)} d ago`;
  return new Date(t).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
